<template>
    <div class="row" v-if="jurisdictions && jurisdictions.length > 0">
        <div class="col-lg-12">
            <div class="card shadow">
                <div class="table-responsive">
                    <base-table 
                        class="table align-items-center table-flush"
                        thead-classes="thead-light"
                        tbody-classes="list"
                        :data="jurisdictions"
                    >
                        <template slot="columns">
                            <th width="2%">S/N</th>
                            <th width="35%">Name</th>
                            <th width="35%">Address</th>
                            <th width="10%">Period</th>
                            <th width="10%">Reg No</th>
                            <th width="5%">&nbsp;</th>
                        </template>

                        <template 
                            slot-scope="{row, index}"
                        >
                        <td class="budget">
                            {{index+1}}
                        </td>
                        <td>
                            {{row.name}}
                        </td>
                        <td>
                            {{row.address}}
                        </td>
                        <td>
                            {{row.period}}
                        </td>
                        <td>
                            {{row.reg_no}}
                        </td>
                        <td>
                            <base-button 
                                type="danger" size="sm"
                                :disabled="lock"
                                @click="$emit('deleteJurisdiction', row.id)"
                            >
                                <i class="fa fa-trash"></i> Remove
                            </base-button>
                        </td>

                        </template>

                    </base-table>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'Jurisdictions',
        props: ["jurisdictions"],
        computed: {
            ...mapGetters(['lock'])
        }
    }
</script>

<style>

</style>
